export const GetClientViewName = (client) => {
    if (client) {
        switch (client.type) {
            case 0:
                return client.privateMetadata.firstName + ' ' +  client.privateMetadata.lastName;
            case 1:
                return client.legalMetadata.name;
            default:
                return 'Undefined';
        }
    }
};